import { useEffect, useState } from 'react';

export function UseAccountantCommissionList(apiCall) {
    const [commissionList, setCommissionList] = useState([]);
    const [showEditCommissionModal, setShowEditCommissionModal] = useState(false);
    const [selectedCommission, setSelectedCommission] = useState(null);

    const fetchCommissionList = async () => {
        try {
            const response = await apiCall();
            setCommissionList(response.data);

            const keys = response.data.map((item, index) => `${index}_${item.productEnergy}_${item.id || index}`);
            const duplicates = keys.filter((key, index) => keys.indexOf(key) !== index);

            if (duplicates.length > 0) {
                console.warn("Duplicate keys found:", duplicates);
                console.log("Data causing duplicates:", response.data);
            }
            console.log("Sales Commission List:", response.data);
        } catch (error) {
            console.error("Error fetching commission data:", error);
        }
    };

    useEffect(() => {
        fetchCommissionList();
    }, []);

    const handleViewCommissionModal = (commission) => () => {
        console.log("Selected commission:", commission);
        setSelectedCommission(commission);
        setShowEditCommissionModal(true);
    };

    const handleCloseEditCommissionModal = () => {
        setShowEditCommissionModal(false);
        setSelectedCommission(null);
    };

    return {
        commissionList,
        showEditCommissionModal,
        selectedCommission,
        handleViewCommissionModal,
        handleCloseEditCommissionModal,
        refetchData: fetchCommissionList
    };
}